import { createActionGroup, props } from '@ngrx/store';

export type ToastPayload = { messageT: string; interpolateParams?: object };

export const { toastSuccess, toastError } = createActionGroup({
  source: `Platform`,
  events: {
    'Toast Success': props<ToastPayload>(),
    'Toast Error': props<ToastPayload>(),
  },
});
